<template>
  <HdModal class="create-note-modal" @close="close">
    <template #title>
      {{ $t('DASHBOARD.CARD.EXPANDED.NOTES.MODAL_TITLE') }}
    </template>
    <template #body>
      <HdForm ref="form" autocomplete="off">
        <HdTextarea
          ref="note"
          v-model="note"
          name="note"
          height="168px"
          class="create-note-modal__textarea"
          :placeholder="$t('DASHBOARD.CARD.EXPANDED.NOTES.PLACEHOLDER')"
          required
        />
      </HdForm>
    </template>
    <template #footer>
      <div class="create-note-modal__actions">
        <HdButton
          class="create-note-modal__action create-note-modal__action--cancel"
          modifier="secondary"
          @click="close"
          >{{ $t('GENERAL.CANCEL') }}</HdButton
        >

        <HdLoaderButton
          class="create-note-modal__action create-note-modal__action--save"
          :label="$t('GENERAL.SAVE')"
          :loading-state="loadingState"
          :disabled="!isActionable"
          :is-static="false"
          :reset-on-success="false"
          @click="saveNewNote"
        />
      </div>
    </template>
  </HdModal>
</template>

<script>
import { HdModal, HdForm, HdTextarea, HdButton, HdLoaderButton } from 'homeday-blocks';
import { ACTION, GETTER, MUTATION } from '@/store/CONSTANTS';
import { createDealNote } from '@/services/apiMapper';

const LOADING_STATE = {
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
};

const IDLE_RESET_TIME = 3000;

export default {
  name: 'CreateNoteModal',
  components: { HdModal, HdForm, HdTextarea, HdButton, HdLoaderButton },
  data() {
    return {
      loadingState: LOADING_STATE.IDLE,
      note: '',
    };
  },
  computed: {
    dealUid() {
      return this.$store.getters[GETTER.DASHBOARD.CREATE_NOTE_MODAL_OPTIONS].dealUid;
    },
    isActionable() {
      return this.loadingState === LOADING_STATE.IDLE && !!this.note;
    },
  },
  beforeDestroy() {
    clearTimeout(this.idleRestTimeout);
  },
  methods: {
    async saveNewNote() {
      if (this.isActionable) {
        try {
          const { dealUid, note } = this;
          await createDealNote({ dealUid, note });
          this.loadingState = LOADING_STATE.SUCCESS;

          if (this.$store.getters[GETTER.DASHBOARD.EXPANDED_DEAL]) {
            await this.$store.dispatch(ACTION.DASHBOARD.FETCH_EXPANDED_DEAL, { dealUid });
          }

          this.idleRestTimeout = setTimeout(this.close, IDLE_RESET_TIME);
        } catch {
          this.$refs?.note?.showError(this.$t('LOGIN.GENERIC_ERROR'));
          this.loadingState = LOADING_STATE.ERROR;

          this.idleRestTimeout = setTimeout(() => {
            this.loadingState = LOADING_STATE.IDLE;
            this.$refs?.note?.hideError();
          }, IDLE_RESET_TIME);
        }
      } else {
        this.$refs?.form?.validate();
      }
    },
    close() {
      this.$store.commit(MUTATION.DASHBOARD.TOGGLE_CREATE_NOTE_MODAL_VISIBILITY);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.create-note-modal {
  &__textarea {
    margin-top: $sp-m;
  }

  &__actions {
    display: flex;
    gap: $sp-s;

    @include for('tablet') {
      gap: $sp-m;
      justify-content: flex-end;
    }
  }

  &__action {
    width: 50%;

    @include for('tablet') {
      width: unset;

      &:last-of-type {
        width: 138px;
      }
    }
  }
}
</style>
